import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity as getSchedulingHistory } from './scheduling-history.reducer';
import { getEntity as getScheduling } from '../scheduling/scheduling.reducer';
// import { getEntity } from '../scheduling/scheduling.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import {
  Box,
  Chip,
  Dialog,
  DialogTitle,
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  ThemeProvider,
  Typography,
  useTheme,
} from '@mui/material';
import { IScheduling } from 'app/shared/model/scheduling.model';
import { Status } from 'app/shared/model/enumerations/scheduling-status.model';
import { CloseRounded, OpenInNewRounded } from '@mui/icons-material';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';

type ISchedulingHistoryDetailModalProps = {
  modalOpen: any;
  setModalOpen: any;
  props: any;
};

export const SchedulingHistoryDetailModal = React.memo(({ modalOpen, setModalOpen, props }: ISchedulingHistoryDetailModalProps) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const id = modalOpen?.id;
  const schedulingHistoryEntity = useAppSelector(state => state.schedulingHistory.entity);
  const schedulingEntity = useAppSelector(state => state.scheduling.entity);
  const schedulingId = schedulingHistoryEntity?.scheduling?.id || '';

  useEffect(() => {
    dispatch(getSchedulingHistory(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (schedulingId) {
      dispatch(getScheduling(schedulingId));
    }
  }, [dispatch, schedulingId]);

  const statusChip = ({ status }: IScheduling) => (
    <Chip
      sx={{ width: '115px' }}
      label={status ? <Translate contentKey={`fleetSenseApp.SchedulingStatus.${status}`} /> : ''}
      color={status === Status.SCHEDULED ? 'warning' : status === Status.CANCELED ? 'error' : 'success'}
    />
  );

  const headers = [
    { key: 'created', sortable: true, component: <Translate contentKey="fleetSenseApp.schedulingHistory.created" /> },
    { key: 'status', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.status" /> },
    { key: 'startTime', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.startTime" /> },
    { key: 'endTime', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.endTime" /> },
    { key: 'description', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.description" /> },
    { key: 'id', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.id" /> },
  ];
  const headers2 = [
    { key: 'truckImplementPlate', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.truckImplementPlate" /> },
    { key: 'truckImplementDescription', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.truckImplementDescription" /> },
    { key: 'userFirstName', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.user" /> },
    { key: 'schedulingType', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.type" /> },
    { key: 'schedulingMethod', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.method" /> },
    { key: 'createdBy', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.createdBy" /> },
  ];
  const toggleModal = () => {
    setModalOpen(prev => !prev);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={modalOpen}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: '15px', background: theme.palette.primary.main } }}
        sx={{
          boxShadow:
            'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
        }}
      >
        <DialogTitle id="dialog-title" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {translate('fleetSenseApp.schedulingHistory.detail.title')}
          <IconButton onClick={toggleModal}>
            <CloseRounded color="secondary" />
          </IconButton>
        </DialogTitle>
        <Box sx={{ height: '40vh' }} padding={'5px'}>
          <Table aria-label="scheduling table">
            <TableHead>
              <TableRow>
                {headers.map((header, i) => (
                  <TableCell
                    key={`entity-${i}`}
                    sx={{
                      borderBottom: 'none',
                      paddingBottom: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        alignItems: 'center',
                      }}
                    >
                      {header.component}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                sx={{
                  whiteSpace: 'nowrap',
                  backgroundColor: 'background.paper',

                  borderTop: '4px solid',
                  borderBottom: '4px solid',
                  borderColor: 'primary.main',
                }}
              >
                <CustomHeadTableCell>
                  {schedulingHistoryEntity?.created ? <TextFormat type="date" value={schedulingHistoryEntity?.created} format={APP_DATE_FORMAT} /> : null}
                </CustomHeadTableCell>
                <CustomHeadTableCell>{statusChip(schedulingEntity)}</CustomHeadTableCell>
                <CustomHeadTableCell>
                  {schedulingEntity?.startTime ? <TextFormat type="date" value={schedulingEntity.startTime} format={APP_DATE_FORMAT} /> : null}
                </CustomHeadTableCell>
                <CustomHeadTableCell>
                  {schedulingHistoryEntity?.scheduling?.endTime ? <TextFormat type="date" value={schedulingEntity.endTime} format={APP_DATE_FORMAT} /> : null}
                </CustomHeadTableCell>
                <CustomHeadTableCell>{schedulingEntity?.description}</CustomHeadTableCell>
                <CustomHeadTableCell>{schedulingEntity?.id}</CustomHeadTableCell>
              </TableRow>
              <TableRow>
                {headers2.map((header, i) => (
                  <TableCell
                    key={`entity-${i}`}
                    sx={{
                      borderBottom: 'none',
                      paddingBottom: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        alignItems: 'center',
                      }}
                    >
                      {header.component}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow
                sx={{
                  whiteSpace: 'nowrap',
                  backgroundColor: 'background.paper',

                  borderTop: '4px solid',
                  borderBottom: '4px solid',
                  borderColor: 'primary.main',
                }}
              >
                <CustomHeadTableCell>
                  {schedulingEntity.truckImplement?.licensePlate}
                  <IconButton color="secondary" component={Link} to={`dashboards/truck-implement/${schedulingEntity?.truckImplement?.id}`}>
                    <OpenInNewRounded fontSize="small" />
                  </IconButton>
                </CustomHeadTableCell>
                <CustomHeadTableCell>{schedulingEntity.truckImplement?.description}</CustomHeadTableCell>
                <CustomHeadTableCell>
                  {schedulingEntity?.user?.firstName} {schedulingEntity?.user?.lastName}
                  <IconButton color="secondary" component={Link} to={`admin/user-management?emailSearch=${encodeURIComponent(schedulingEntity?.user?.email)}`}>
                    <OpenInNewRounded fontSize="small" />
                  </IconButton>
                </CustomHeadTableCell>
                <CustomHeadTableCell>{translate(`fleetSenseApp.SchedulingTypes.${schedulingEntity?.type}`)}</CustomHeadTableCell>
                <CustomHeadTableCell>{translate(`fleetSenseApp.SchedulingMethod.${schedulingEntity?.method}`)}</CustomHeadTableCell>
                <CustomHeadTableCell>{schedulingEntity?.createdBy}</CustomHeadTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Dialog>
    </ThemeProvider>
  );
});

const CustomHeadTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}));
